import { Outlet, useNavigate } from "react-router-dom";

export default function DailyMain(props) {
  return (
    <>
      <Outlet />
    </>
  );
}
